Fastweb.Colleges = (function($) {

  initMyColleges = function(current_filter) {
    $('#users_colleges_tabs').foundation('selectTab', $('#' + current_filter), true);
  }

  return {initMyColleges: initMyColleges}

})(jQuery);
